export default __webpack_public_path__ + "static/media/javascript-logo.aea07091.svg";